import { Component, type ErrorInfo, type ReactNode } from 'react'

/** A render fault must not leave a blank page: show the error and a way back. */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('loco render error', error, info.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children
    return (
      <div className="m-4 max-w-2xl rounded border border-rose-300 bg-rose-50 p-4" role="alert">
        <h1 className="text-sm font-semibold text-rose-900">This view failed to render</h1>
        <pre className="mt-2 overflow-x-auto whitespace-pre-wrap text-2xs text-rose-900">
          {this.state.error.message}
        </pre>
        <button className="btn mt-3" onClick={() => this.setState({ error: null })}>
          Try again
        </button>
      </div>
    )
  }
}
